module.exports = __webpack_public_path__ + "img/blueCircle.8234cda2.png";